module.exports = require("@swa-ui/core/src/Separator/Separator.module.scss");